define('models/pixelInContainer',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  T1.Models.PixelEventUrl = T1Model.extend({
    url: "pixels/",
    isNew: function () {
      return this.get("action") === "new";
    },
    canEdit: function () {
      var deferred = $.Deferred();
      deferred.resolve(true);
      return deferred;
    },
    drop: function (successHandler, errorHandler) {
      if (this.id) {
        this.save({
          id: this.id,
          version: this.get("version")
        }, {
          action: "delete",
          success: successHandler || $.noop,
          conflict: errorHandler || $.noop
        });
      } else {
        successHandler();
      }
    }
  });
  return T1.Models.PixelEventUrl;
});
